export interface EnumType {[s: number]: string}

export module EnumUtils {

    // Only works with numeric enums
    export function loopEnums(targetEnum: EnumType, block: (element: string, elementNo: number) => void) {
        for(const element in targetEnum) {
            const elementNo = Number(element)
            if(!isNaN(elementNo)) {
                block(element, elementNo)
            }
        }
    }

    // Works with both numeric and string enums
    export function iterateEnum(targetEnum: EnumType, callback: (value: any) => void) {
        for(const enumValue in targetEnum) {
            if(isNaN(Number(enumValue))) {
                callback(targetEnum[enumValue])
            }
        }
    }

    export function getLength(targetEnum: EnumType): number {
        const enumKeys = Object.keys(targetEnum)
        return enumKeys.filter((key) => isNaN(Number(key))).length
    }

    export function getEnumKey<EnumT, EnumTypeT>(enumValue: EnumT, enumType: EnumTypeT): keyof EnumTypeT {
        return enumType[enumValue as any] as keyof EnumTypeT
    }
}
